export default __webpack_public_path__ + "static/media/kid14.c4974595.jpg";